import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Checkbox,
  VStack,
  useToast,
  HStack,
  Select,
  Box,
  Text,
  Progress,
} from "@chakra-ui/react";
import { supabase } from "../../lib/supabaseClient";
import { useAuth } from "../../context/AuthContext";

const DEBUT_COUNTRIES = [
  { value: "대한민국", label: "대한민국" },
  { value: "미국", label: "미국" },
  { value: "기타", label: "기타" },
];

const LANGUAGES = [
  { value: "한국어", label: "한국어" },
  { value: "영어", label: "영어" },
  { value: "기타", label: "기타" },
];

const COMPOSITIONS = [
  { value: "솔로", label: "솔로" },
  { value: "그룹", label: "그룹" },
  { value: "기타", label: "기타" },
];

const GENDERS = [
  { value: "남성", label: "남성" },
  { value: "여성", label: "여성" },
  { value: "혼성", label: "혼성" },
  { value: "기타", label: "기타" },
];

const GENRES = [
  { value: "트로트", label: "트로트" },
  { value: "Ballad (국내)", label: "발라드 (국내)" },
  { value: "Blues (국내)", label: "블루스 (국내)" },
  { value: "Dance (국내)", label: "댄스 (국내)" },
  { value: "Folk (국내)", label: "포크 (국내)" },
  { value: "R&B / Soul (국내)", label: "알앤비 / 소울 (국내)" },
  { value: "Rap / Hip-hop (국내)", label: "랩 / 힙합 (국내)" },
  { value: "Rock (국내)", label: "록 (국내)" },
  { value: "Electronica (국내)", label: "일렉트로니카 (국내)" },
  { value: "CCM (국내)", label: "CCM (국내)" },
  { value: "Jazz (국내)", label: "재즈 (국내)" },
  { value: "OST (국내)", label: "OST (국내)" },
  { value: "Blues (국외)", label: "블루스 (국외)" },
  { value: "Country (국외)", label: "컨트리 (국외)" },
  { value: "Electronica (국외)", label: "일렉트로니카 (국외)" },
  { value: "Folk (국외)", label: "포크 (국외)" },
  { value: "Pop (국외)", label: "팝 (국외)" },
  { value: "EDM (국외)", label: "EDM (국외)" },
  { value: "R&B / Soul (국외)", label: "알앤비 / 소울 (국외)" },
  { value: "Rap / Hip-hop (국외)", label: "랩 / 힙합 (국외)" },
  { value: "Rock (국외)", label: "록 (국외)" },
  { value: "CCM (국외)", label: "CCM (국외)" },
  { value: "Jazz (국외)", label: "재즈 (국외)" },
  { value: "OST (국외)", label: "OST (국외)" },
  { value: "한국전통음악", label: "한국전통음악" },
  { value: "어린이음악", label: "어린이음악" },
  { value: "종교음악", label: "종교음악" },
  { value: "Classic", label: "클래식" },
  { value: "New Age", label: "뉴에이지" },
  { value: "뮤직테라피", label: "뮤직테라피" },
  { value: "기타", label: "기타" },
  { value: "월드뮤직", label: "월드뮤직" },
  { value: "Electronica (J-Pop)", label: "일렉트로니카 (J-Pop)" },
  { value: "Pop (J-Pop)", label: "팝 (J-Pop)" },
  { value: "R&B / Soul (J-Pop)", label: "알앤비 / 소울 (J-Pop)" },
  { value: "Rap / Hip-hop (J-Pop)", label: "랩 / 힙합 (J-Pop)" },
  { value: "Rock (J-Pop)", label: "록 (J-Pop)" },
];

const MusicianModal = ({ isOpen, onClose, onSuccess }) => {
  const { user } = useAuth();
  const [musicianName, setMusicianName] = useState("");
  const [realNameKr, setRealNameKr] = useState("");
  const [realNameEn, setRealNameEn] = useState("");
  const [debutCountry, setDebutCountry] = useState("");
  const [language, setLanguage] = useState("");
  const [mainGenre, setMainGenre] = useState("");
  const [composition, setComposition] = useState("");
  const [gender, setGender] = useState("");
  const [debutYear, setDebutYear] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [isIdol, setIsIdol] = useState(false);
  const [description, setDescription] = useState("");
  const [biography, setBiography] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [realImage, setRealImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({ profile: 0, real: 0 });
  const [uploadStatus, setUploadStatus] = useState("");
  const toast = useToast();

  const uploadFile = async (file, path) => {
    try {
      const fileExt = file.name.split(".").pop()?.toLowerCase() || path;
      const timestamp = new Date().getTime();
      const fileName = `musician_${timestamp}.${fileExt}`;
      const filePath = `${path}/${fileName}`;

      setUploadStatus(`"${file.name}" 파일 업로드 중...`);

      const { data, error: urlError } = await supabase.storage
        .from("image")
        .createSignedUploadUrl(filePath);

      if (urlError || !data?.signedUrl) {
        console.error("URL 발급 오류:", urlError);
        throw new Error("Signed URL 발급 실패");
      }

      const signedUrl = data.signedUrl;

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", signedUrl, true);
        xhr.setRequestHeader("Content-Type", file.type || "image/jpeg");

        xhr.upload.onprogress = (e) => {
          if (e.lengthComputable) {
            setUploadProgress((prev) => ({
              ...prev,
              [path]: Math.round((e.loaded / e.total) * 100),
            }));
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve();
          } else {
            console.error("업로드 실패 상세:", {
              status: xhr.status,
              statusText: xhr.statusText,
              response: xhr.response,
            });
            reject(new Error(`업로드 실패: ${xhr.status} ${xhr.statusText}`));
          }
        };
        xhr.onerror = () => {
          console.error("네트워크 오류 상세:", xhr);
          reject(new Error("네트워크 오류가 발생했습니다."));
        };
        xhr.send(file);
      });

      const { data: publicUrlData } = supabase.storage
        .from("image")
        .getPublicUrl(filePath);

      return publicUrlData?.publicUrl;
    } catch (error) {
      console.error("파일 업로드 중 오류 발생:", error);
      throw error;
    }
  };

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const ext = file.name.split(".").pop().toLowerCase();
      if (ext !== "jpg" && ext !== "jpeg") {
        toast({
          title: "이미지 파일 형식 오류",
          description: "JPG 파일만 업로드할 수 있습니다.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        e.target.value = "";
        return;
      }
      setProfileImage(file);
    }
  };

  const handleRealImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const ext = file.name.split(".").pop().toLowerCase();
      if (ext !== "jpg" && ext !== "jpeg") {
        toast({
          title: "이미지 파일 형식 오류",
          description: "JPG 파일만 업로드할 수 있습니다.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        e.target.value = "";
        return;
      }
      setRealImage(file);
    }
  };

  const handleSubmit = async () => {
    const missingFields = [];
    if (!musicianName.trim()) missingFields.push("뮤지션 활동명");
    if (!realNameKr.trim()) missingFields.push("뮤지션 본명 (국문)");
    if (!realNameEn.trim()) missingFields.push("뮤지션 본명 (영문)");
    if (!debutCountry.trim()) missingFields.push("데뷔 국가");
    if (!language.trim()) missingFields.push("가창 언어");
    if (!composition.trim()) missingFields.push("구성");
    if (!gender.trim()) missingFields.push("성별");
    // 멜론 신규 아티스트 등록 요청 메일의 필수 항목 — 비면 메일 본문에 "(확인 필요)"로 나간다.
    if (!birthdate.trim()) missingFields.push("생년월일");
    if (!realImage) missingFields.push("실물 이미지");

    if (missingFields.length > 0) {
      toast({
        title: "필수 정보 누락",
        description: `${missingFields.join(", ")}`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    setIsLoading(true);
    try {
      // jpg 파일만 허용
      if (profileImage) {
        const ext = profileImage.name.split(".").pop().toLowerCase();
        if (ext !== "jpg" && ext !== "jpeg") {
          toast({
            title: "이미지 파일 형식 오류",
            description: "JPG 파일만 업로드할 수 있습니다.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setIsLoading(false);
          return;
        }
      }
      if (realImage) {
        const ext = realImage.name.split(".").pop().toLowerCase();
        if (ext !== "jpg" && ext !== "jpeg") {
          toast({
            title: "이미지 파일 형식 오류",
            description: "JPG 파일만 업로드할 수 있습니다.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setIsLoading(false);
          return;
        }
      }
      setUploadStatus("이미지 파일 업로드 중...");
      const [profileImageUrl, realImageUrl] = await Promise.all([
        profileImage
          ? uploadFile(profileImage, `musician/${user.email}`)
          : null,
        uploadFile(realImage, `musician/${user.email}/real`),
      ]);

      if (!realImageUrl) {
        throw new Error("실물 이미지 업로드에 실패했습니다.");
      }

      // 뮤지션 데이터 저장
      const { error: insertError } = await supabase.from("musician").insert({
        name_musician: musicianName,
        name_korean: realNameKr,
        name_english: realNameEn,
        debut_nation: debutCountry,
        language: language,
        genre: mainGenre,
        type_musician: composition,
        sex_musician: gender,
        debut_year: debutYear,
        date_of_birth: birthdate,
        idol: isIdol,
        introduction: description,
        biography: biography,
        image_profile: profileImageUrl,
        image_verification: realImageUrl,
        user: user.email,
      });

      if (insertError) {
        throw insertError;
      }

      toast({
        title: "뮤지션이 성공적으로 등록되었습니다.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // 입력 필드 초기화
      setMusicianName("");
      setRealNameKr("");
      setRealNameEn("");
      setDebutCountry("");
      setLanguage("");
      setMainGenre("");
      setComposition("");
      setGender("");
      setDebutYear("");
      setBirthdate("");
      setIsIdol(false);
      setDescription("");
      setBiography("");
      setProfileImage(null);
      setRealImage(null);

      // 모달 닫기
      onClose();

      // 성공 후 콜백 실행 (데이터 새로고침)
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error("Error creating musician:", error);
      toast({
        title: "뮤지션 등록 중 오류가 발생했습니다.",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
      setUploadProgress({ profile: 0, real: 0 });
      setUploadStatus("");
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent maxW="800px" borderRadius="xl" boxShadow="xl">
        <ModalHeader
          bg="blue.50"
          borderTopRadius="xl"
          py={4}
          fontSize="xl"
          fontWeight="bold"
          color="blue.700"
        >
          뮤지션 추가
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={6}>
          <VStack spacing={6}>
            <HStack width="100%" spacing={4}>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  뮤지션 활동명
                </FormLabel>
                <Input
                  value={musicianName}
                  onChange={(e) => setMusicianName(e.target.value)}
                  placeholder="활동명을 입력하세요. 예시) 아이유"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  아이돌 여부
                </FormLabel>
                <Checkbox
                  isChecked={isIdol}
                  onChange={(e) => setIsIdol(e.target.checked)}
                  colorScheme="blue"
                  size="lg"
                >
                  아이돌 그룹
                </Checkbox>
              </FormControl>
            </HStack>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  뮤지션 본명 (국문)
                </FormLabel>
                <Input
                  value={realNameKr}
                  onChange={(e) => setRealNameKr(e.target.value)}
                  placeholder="국문 본명을 입력하세요. 예시) 이지은"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  뮤지션 본명 (영문)
                </FormLabel>
                <Input
                  value={realNameEn}
                  onChange={(e) => setRealNameEn(e.target.value)}
                  placeholder="영문 본명을 입력하세요. 예시) Lee Ji eun"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
            </HStack>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  데뷔 국가
                </FormLabel>
                <Select
                  value={debutCountry}
                  onChange={(e) => setDebutCountry(e.target.value)}
                  placeholder="데뷔 국가를 선택하세요"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                >
                  {DEBUT_COUNTRIES.map((country) => (
                    <option key={country.value} value={country.value}>
                      {country.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  가창 언어
                </FormLabel>
                <Select
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                  placeholder="가창 언어를 선택하세요"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                >
                  {LANGUAGES.map((lang) => (
                    <option key={lang.value} value={lang.value}>
                      {lang.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </HStack>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  메인 장르
                </FormLabel>
                <Select
                  value={mainGenre}
                  onChange={(e) => setMainGenre(e.target.value)}
                  placeholder="메인 장르를 선택하세요"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                >
                  {GENRES.map((genre) => (
                    <option key={genre.value} value={genre.value}>
                      {genre.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  구성
                </FormLabel>
                <Select
                  value={composition}
                  onChange={(e) => setComposition(e.target.value)}
                  placeholder="구성을 선택하세요"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                >
                  {COMPOSITIONS.map((comp) => (
                    <option key={comp.value} value={comp.value}>
                      {comp.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </HStack>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  성별
                </FormLabel>
                <Select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  placeholder="성별을 선택하세요"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                >
                  {GENDERS.map((g) => (
                    <option key={g.value} value={g.value}>
                      {g.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  데뷔년도
                </FormLabel>
                <Input
                  value={debutYear}
                  onChange={(e) => setDebutYear(e.target.value)}
                  placeholder="예시) 2025"
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  생년월일
                </FormLabel>
                <Input
                  type="date"
                  value={birthdate}
                  onChange={(e) => setBirthdate(e.target.value)}
                  borderRadius="md"
                  focusBorderColor="blue.400"
                />
              </FormControl>
            </HStack>

            <FormControl>
              <FormLabel fontWeight="medium" color="gray.700">
                자기 소개
              </FormLabel>
              <Textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="자기 소개를 입력하세요"
                rows={3}
                borderRadius="md"
                focusBorderColor="blue.400"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="medium" color="gray.700">
                활동 이력
              </FormLabel>
              <Textarea
                value={biography}
                onChange={(e) => setBiography(e.target.value)}
                placeholder={`활동 이력 및 아티스트 URL을 입력하세요.
신규 아티스트 일 경우, "신규" 입력
예:
    - 활동 이력: 2023년 데뷔, 2024년 첫 앨범 발매
    - 아티스트 URL: https://www.melon.com/artist/timeline.htm?artistId=261143`}
                rows={6}
                borderRadius="md"
                focusBorderColor="blue.400"
              />
            </FormControl>

            <HStack width="100%" spacing={4}>
              <FormControl flex={1}>
                <FormLabel fontWeight="medium" color="gray.700">
                  프로필 이미지
                </FormLabel>
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleProfileImageChange}
                  borderRadius="md"
                  p={1}
                />
              </FormControl>
              <FormControl flex={1} isRequired>
                <FormLabel fontWeight="medium" color="gray.700">
                  실물 이미지
                </FormLabel>
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleRealImageChange}
                  borderRadius="md"
                  p={1}
                />
              </FormControl>
            </HStack>

            {isLoading && (
              <Box width="100%" p={4} bg="blue.50" borderRadius="lg">
                <Text mb={2} fontWeight="medium" color="blue.700">
                  {uploadStatus}
                </Text>
                <VStack spacing={3}>
                  {profileImage && (
                    <Box width="100%">
                      <Text fontSize="sm" mb={1} color="blue.600">
                        프로필 이미지 업로드 진행률
                      </Text>
                      <Progress
                        value={uploadProgress.profile}
                        size="sm"
                        colorScheme="blue"
                        borderRadius="full"
                        hasStripe
                        isAnimated
                      />
                    </Box>
                  )}
                  <Box width="100%">
                    <Text fontSize="sm" mb={1} color="blue.600">
                      실물 이미지 업로드 진행률
                    </Text>
                    <Progress
                      value={uploadProgress.real}
                      size="sm"
                      colorScheme="blue"
                      borderRadius="full"
                      hasStripe
                      isAnimated
                    />
                  </Box>
                </VStack>
              </Box>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter p={4} borderTopWidth={1} borderColor="gray.200">
          <Button variant="ghost" mr={3} onClick={onClose}>
            취소
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={isLoading}
            loadingText="등록 중..."
          >
            등록
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MusicianModal;
